import React, { useRef } from "react";

import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import "./TrackProgress.css";

function TrackProgress(props) {
  const contentRef = useRef(null);
  const { height } = useResizeObserver(contentRef);
  return (
    <div>
      <div
        style={{
          position: "sticky",
          top: "0",
          zIndex: "100",
          transition: "background-color 0.5s ease"
        }}
        className="display-flex flex-align-items-center background-color-tertiaryColor2"
      >
        <CircleIndicators state={props.state} />
        {props.title && (
          <div
            style={{
              fontWeight: "400"
            }}
            className="padding-left-large font-size-medium text-uppercase font-color-tertiaryColor"
          >
            {props.title}
          </div>
        )}
      </div>
      <div className="display-flex inherit-parent-height">
        <div
          style={{
            height: `${height}px`,
            paddingRight: "4px",
            paddingLeft: "4px"
          }}
          className="width-16px flex-align-items-center flex-justify-content-center"
        >
          <div
            style={{ width: "2px" }}
            className={`inherit-parent-height ${
              props.isLast ? "" : "black-dashed-border"
            }`}
          />
        </div>
        <div
          ref={contentRef}
          style={{
            textAlign: "justify"
          }}
          className="padding-left-large padding-right-large padding-top-small padding-bottom-large inherit-parent-height inherit-parent-width font-size-small"
        >
          {props.data}
        </div>
      </div>
    </div>
  );
}

export default TrackProgress;

const CircleIndicators = (props) => {
  return (
    <>
      {props.state === "ACTIVE" && (
        <div
          style={{
            width: "10px",
            height: "10px",
            backgroundColor: "var(--secondaryColor)",
            borderRadius: "50%"
          }}
        />
      )}
      {props.state === "FAILED" && (
        <div
          style={{
            width: "10px",
            height: "10px",
            backgroundColor: "#D0405A",
            borderRadius: "50%"
          }}
        />
      )}
      {props.state === "INACTIVE" && (
        <div
          style={{
            width: "10px",
            height: "10px",
            backgroundColor: "#3E3E3E",
            borderRadius: "50%"
          }}
        />
      )}
      {props.state === "PROGRESS" && (
        <div
          style={{
            width: "10px",
            height: "10px",
            backgroundColor: "#3a3a3a",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div
            style={{
              width: "6px",
              height: "6px",
              backgroundColor: "#1a1a1a",
              borderRadius: "50%"
            }}
          ></div>
        </div>
      )}
    </>
  );
};
